const styles = () => ({
    paper: {
        overflow: 'hidden',
    },
    paperContent: {
        overflow: 'hidden',
        paddingBottom: '20px',
    },
});

export default styles;
